<template>
   <v-container fluid grid-list-xl py-0>
			<v-layout row wrap>
        
				<app-card
					:heading="''"
					:fullBlock="true"
					colClasses="xl9 lg9 md12 sm12 xs12"
				>

                        <v-toolbar color="white" light>
                            <v-toolbar-title>Werkuren van {{this.record.UserName}} (instelbaar in windows programma)</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
					
					<v-data-table
						v-bind:headers="headersTrans"
						v-bind:items="this.record.UserHours" :rows-per-page-items="[-1]">
						<template slot="items" slot-scope="props">
							<td>{{getTime(props.item.DatFrom)}}</td>
                            <td>{{getTime(props.item.DatTo)}}</td>
                            <td>
                                <span v-if="props.item.OptWeek === 1">Algemeen/even</span>
                                <span v-else>oneven</span>
                            </td>
                            <td><v-checkbox disabled v-model="props.item.IsMon"></v-checkbox></td>
             				<td><v-checkbox disabled v-model="props.item.IsTue"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsWed"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsThu"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsFri"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsSat"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsSun"></v-checkbox></td>
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>
                <app-card
					:heading="''"
					:fullBlock="true"
					colClasses="xl12"
				>
                    <v-toolbar color="white" light>
                            <v-toolbar-title>Uitzonderingsuren van {{this.record.UserName}} (enkel online)</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon>
                                <v-icon @click="newExWorkHour()">add</v-icon>
                            </v-btn>
                        </v-toolbar>
					
					<v-data-table
						v-bind:headers="headersTransEx"
						v-bind:items="this.record.ExceptHours"
                         :rows-per-page-items="[-1]"
                        >
						<template slot="items" slot-scope="props">
							<td>{{getTimeDt(props.item.DatFrom)}}</td>
                            <td>{{getTimeDt(props.item.DatTo)}}</td>
                            <td>{{getKind(props.item.KindID)}}</td>
                            <td><v-checkbox disabled v-model="props.item.IsMon"></v-checkbox></td>
             				<td><v-checkbox disabled v-model="props.item.IsTue"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsWed"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsThu"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsFri"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsSat"></v-checkbox></td>
                            <td><v-checkbox disabled v-model="props.item.IsSun"></v-checkbox></td>
                            <td><v-btn flat @click="askDelWorkHourEx (props.item)">Wis</v-btn></td>
							<td><v-btn flat @click="editRecWorkHourEx (props.item)">Wijzig</v-btn></td>
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>
			</v-layout>

            <v-dialog v-model="dlgAddWorkHour" max-width="500" max-heigh="600">
						<v-card>
							<v-card-title class="headline">Nieuwe werkuren opzetten</v-card-title>
							<v-card-text>
                                <v-layout row wrap>
                                
                                <v-flex v-if="this.isExceptHours === false" xs4 sm4><vue-timepicker  v-model="timeHHMMStart"></vue-timepicker></v-flex>
                                <v-flex v-if="this.isExceptHours === false" xs4 sm4 align-content-center="true"><span style="text-align:center">Tot</span></v-flex>
                                <v-flex  v-if="this.isExceptHours === false" xs4 sm4><vue-timepicker  v-model="timeHHMMEnd"></vue-timepicker></v-flex>

                                <v-flex v-if="this.isExceptHours === true" xs6 sm6 align-content-center="true"><datepicker v-model="datExStart"></datepicker></v-flex>
                                <v-flex v-if="this.isExceptHours === true" xs6 sm6><vue-timepicker  v-model="timeHHMMStart"></vue-timepicker></v-flex>
                                
                                <v-flex v-if="this.isExceptHours === true" xs6 sm6 align-content-center="true"><datepicker v-model="datExEnd"></datepicker></v-flex>
                                <v-flex  v-if="this.isExceptHours === true" xs4 sm6><vue-timepicker  v-model="timeHHMMEnd"></vue-timepicker></v-flex>

                                 <v-flex xs12 class="col-height-auto" v-if="this.isExceptHours === true">
                                        <v-select  hide-details v-bind:items="kindexceptLst" item-value="value" item-text="text" v-model="currentRec.KindID"  label="Soort uitzondering"  
                                        single-line  menu-props="auto" ></v-select>
                                </v-flex>

                                <v-flex xs6 sm6 md6 class="col-height-auto">
                                <v-checkbox label="Maandag" v-model="currentRec.IsMon"></v-checkbox>
                                <v-checkbox label="Dinsdag" v-model="currentRec.IsTue"></v-checkbox>
                                <v-checkbox label="Woensdag" v-model="currentRec.IsWed"></v-checkbox>
                                <v-checkbox label="Donderdag" v-model="currentRec.IsThu"></v-checkbox>
                                </v-flex>

                                <v-flex xs6 sm6 md6 class="col-height-auto">
                                <v-checkbox label="Vrijdag" v-model="currentRec.IsFri"></v-checkbox>
                                <v-checkbox label="Zaterdag" v-model="currentRec.IsSat"></v-checkbox>
                                <v-checkbox label="Zondag" v-model="currentRec.IsSun"></v-checkbox>
                                </v-flex>
                                </v-layout>
                            </v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="warning" flat="flat" @click.native="dlgAddWorkHour = false">Annuleer</v-btn>
								<v-btn color="error" flat="flat" @click.native="saveWorkHour(currentRec)">Bewaar</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

                    <v-dialog v-model="dlgDelRec" max-width="500">
						<v-card>
							<v-card-title class="headline">Record verwijderen?</v-card-title>
							<v-card-text>Ben je zeker dat je dit record wenst te verwijderen ?</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="warning" flat="flat" @click.native="dlgDelRec = false">Nee</v-btn>
								<v-btn color="error" flat="flat" @click.native="delWorkHour(currentRec)">Ja</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

  	</v-container>


</template>

<script>

import myHttpApi from "../../api/myHttpApi";
import router from '../../router';
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker';

export default {
  props: {
      record : Object
  },
   components: {
       VueTimepicker,
       Datepicker
  },
  mounted() {
	  //console.log  (moment(String('2000-01-01T09:00:13')).format('MM/DD/YYYY hh:mm'));
  },
  data() {
    return {
        currentRec : {},
        dialog4 : false,
        dlgAddWorkHour : false,
        dlgDelRec : false,
        isExceptHours : false,
        isAddRecord : false,
        timeHHMMStart :  {},
        datExStart : '',
        datExEnd : '',
        kindexceptLst : [
            {text: "Aanwezig", value:2},
            {text: "Afwezig", value:1}
        ],
        timeHHMMEnd :  {
                HH: "18",
                mm: "00",
                ss: "00"
            },
		headersTrans: [
			{ text: "Start", value:""},
            { text: "Einde", value:""},
            { text: "Soort", value:""},
            { text: "Ma", value:""},
            { text: "Di", value:""},
            { text: "Woe", value:""},
            { text: "Do", value:""},
            { text: "Vrij", value:""},
            { text: "Za", value:""},
            { text: "Zo", value:""}
        ],
        headersTransEx: [
			{ text: "Start", value:""},
            { text: "Einde", value:""},
            { text: "Soort", value:""},
            { text: "Ma", value:""},
            { text: "Di", value:""},
            { text: "Woe", value:""},
            { text: "Do", value:""},
            { text: "Vrij", value:""},
            { text: "Za", value:""},
            { text: "Zo", value:""}
        ]
    }
  },
   methods: {
       newWorkHour (){
          this.isAddRecord = true;
          this.isExceptHours = false;
          this.getTableDataNewRec ();
       },
       newExWorkHour () {
          this.isAddRecord = true;
          this.isExceptHours = true;
          this.getTableDataNewRec ();
       },
       askDelWorkHour (rec) {
           this.currentRec = rec;
           this.isExceptHours = false;
           this.dlgDelRec = true;
       },
       askDelWorkHourEx(rec) {
           this.currentRec = rec;
           this.isExceptHours = true;
           this.dlgDelRec = true;
       },
       editRecWorkHour (rec) {
           this.currentRec = rec;

           this.timeHHMMStart =  {
                            HH: moment(String(rec.DatFrom)).format('HH'),
                            mm: moment(String(rec.DatFrom)).format('mm'),
                            ss: "00"
                        };
             this.timeHHMMEnd =  {
                            HH: moment(String(rec.DatTo)).format('HH'),
                            mm: moment(String(rec.DatTo)).format('mm'),
                            ss: "00"
                        };
           this.datExStart = this.getDate (rec.DatFrom); 
           this.datExEnd = this.getDate (rec.DatTo);
           this.dlgAddWorkHour = true;
       },
       saveWorkHour(rec){
           
           rec.DatFrom = "2010-01-01T" + this.timeHHMMStart.HH + ":" + this.timeHHMMStart.mm + ":00";
           rec.DatTo = "2010-01-01T" + this.timeHHMMEnd.HH + ":" + this.timeHHMMEnd.mm + ":00";

           if (this.isExceptHours)
           {
               rec.DatFrom = moment(String(this.datExStart)).format('YYYY-MM-DD') + "T" + this.timeHHMMStart.HH + ":" + this.timeHHMMStart.mm + ":00";
               rec.DatTo = moment(String(this.datExEnd)).format('YYYY-MM-DD') + "T" + this.timeHHMMEnd.HH + ":" + this.timeHHMMEnd.mm + ":00";
           }

            myHttpApi
                myHttpApi.post('BOUser/SaveWorkHour', rec)
                .then(response => {
                  this.loader = false;

                  if ((this.isExceptHours) && (this.isAddRecord))
                  {
                    this.record.ExceptHours = this.record.ExceptHours.concat (rec);
                  }
                  else
                  {
                    this.record.UserHours = this.record.UserHours.concat (rec);
                  }
                  this.isAddRecord = false;
                  this.dlgAddWorkHour = false;
                })
                .catch(error => {
                console.log(error);
                });
       },
       delWorkHour (rec){
            myHttpApi
                myHttpApi.post('BOUser/DelWorkHour', rec)
                .then(response => {
                  this.loader = false;

                  if (this.isExceptHours)
                  {
                    this.record.ExceptHours.splice(this.record.ExceptHours.indexOf(rec), 1);
                  }
                  else
                  {
                    this.record.UserHours.splice(this.record.UserHours.indexOf(rec), 1);
                  }
                  this.dlgDelRec = false;
                })
                .catch(error => {
                console.log(error);
                });
       },
       editRecWorkHourEx (rec) {
           this.isExceptHours = true;
           this.editRecWorkHour  (rec);
       },
       getTime (rec) {
           return moment(String(rec)).format('HH:mm');
       },
       getTimeDt (rec) {
           return moment(String(rec)).format('D MMM YYYY  - HH:mm');
       },
       getDate (rec) {
           return moment(String(rec)).format('YYYY-MM-DD');
       },
       getKind (rec)  {
           if (rec == 1) return "Afwezig";
           else return "Aanwezig";
       },
        getTableDataNewRec() {
            myHttpApi
                console.log (this.record);
                const searchRec = {Search: this.record.UserID, Extra: ""}
                myHttpApi.post('BOUser/GetNewWorkHour', searchRec)
                .then(response => {
                  this.loader = false;
                  this.currentRec = response.data;
                  if (this.isExceptHours) {this.currentRec.KindID = 10;}
                  this.editRecWorkHour (this.currentRec);
                })
                .catch(error => {
                console.log(error);
                });
	}
  }
};
</script>
